<template>
  <loader v-if="loading"></loader>
  <find-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :filters="filters"
    :page-request="pageRequest"
    :sorters="sorters"
    :page="page"

    filters-title="Ricerca gruppi di lavoro"
    results-title="Gruppi di lavoro"
    no-results-message="Nessun gruppo di lavoro trovato"

    @selectPageSize="selectPageSize"
    @find="find"
    @sort="sortBy"
    @selectPage="selectPage">
    <b-card slot="filters">
      <workgroup-filters v-model="filters" />
    </b-card>
    <b-row slot="results">
      <b-modal
        ref="usersModal"
        :title="selectedWorkgroup && selectedWorkgroup.name"
        size="xl"
        bodyClass="p-0"
        ok-only
        scrollable
        @ok="usersInWorkgroup = null"
        @close="usersInWorkgroup = null">
        <b-list-group>
          <b-list-group-item v-for="u in usersInWorkgroup">
            {{ u.displayName }}
            <tag-list :value="tagsForUser(u)" />
          </b-list-group-item>
        </b-list-group>
      </b-modal>
      <b-col v-for="r in page.content" sm="6" md="4">
        <router-link-card
          :disabled="!r.permissions.load"
          :to="{ name: 'Workgroup', params: { id: r.id } }"
          @disabledClick="showUsers(r)">
          <div>
            {{ r.name }} <tag-list :value="tagsFor(r)" />
          </div>
        </router-link-card>
      </b-col>
    </b-row>
    <div
      v-if="page.permissions && page.permissions.create"
      slot="bottom-buttons"
      class="text-right mb-2">
      <b-button variant="success" :to="{ name: 'Workgroup', params: { id: 'new' } }">
        Nuovo
      </b-button>
    </div>
  </find-page-layout>
</template>
<script>
import WorkgroupService from 'app/services/WorkgroupService';
import UserService from 'app/services/UserService';
import FindPageMixin from 'vue-core/mixins/FindPageMixin';
import { error2text } from 'core/utils';

export default {
  mixins: [ FindPageMixin ],

  created() {
    this.service = WorkgroupService;
  },

  data() {
    return {
      selectedWorkgroup: null,
      usersInWorkgroup: null
    };
  },

  watch: {
    usersInWorkgroup(newValue) {
      if (newValue) {
        this.$refs.usersModal.show();
      } else {
        this.$refs.usersModal.hide();
        this.selectedWorkgroup = null;
      }
    }
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Gruppi di lavoro'
        }
      ];
    },

    sorters() {
      return [
        {
          label: 'Nome',
          path: 'name'
        },
      ];
    }
  },

  methods: {
    tagsFor(result) {
      const ret = [];
      if (!result.type) {
        ret.push({
          text: 'Indiretto',
          variant: 'secondary'
        });
      } else if (result.type === 'ADMINISTRATOR') {
        ret.push({
          text: 'Amministrato',
          variant: 'primary'
        });
      } else if (result.type === 'ORDINARY') {
        ret.push({
          text: 'Ordinario',
          variant: 'success'
        });
      } else if (result.type === 'GUEST') {
        ret.push({
          text: 'Ospite',
          variant: 'warning'
        });
      }
      return ret;
    },

    tagsForUser(user) {
      const item = user.workgroups
          .find(wg => wg.workgroup.id === this.selectedWorkgroup.id);

      let text, variant;
      if (item.type === 'ADMINISTRATOR') {
        text = 'Amministratore';
        variant = 'primary';
      } else if (item.type === 'ORDINARY') {
        text = 'Ordinario';
        variant = 'success';
      } else if (item.type === 'GUEST') {
        text = 'Ospite';
        variant = 'warning';
      }
      return [{ text, variant }];
    },

    showUsers(result) {
      const success = ({ statusCode, data }) => {
        console.log('Success:', statusCode, data);
        this.selectedWorkgroup = result;
        this.usersInWorkgroup = data.content;
      };

      const error = ({ statusCode, data }) => {
        console.log('Error:', statusCode, data);
        alert(error2text(data));
      };

      const parameters = {
        workgroupIds: [ result.id ]
      };

      UserService.find({ parameters })
        .then(success, error);
    }
  }
}
</script>
